import React, { useState } from 'react';
import { Button, Card, Space, Typography, Alert, message } from 'antd';
import { syncEventVideoFromAffiliates } from '@/server/publications/publicationServer';

const { Paragraph, Text } = Typography;

/**
 * Bulk-assign event videoStory (+ HLS / qualities) from affiliated profiles' gallery media.
 * Calls POST /api/backoffice/events/sync-video-from-affiliates (admin JWT required).
 */
export default function EventVideoAffiliateSyncCard() {
  const [loading, setLoading] = useState(false);
  const [dryLoading, setDryLoading] = useState(false);
  const [lastSummary, setLastSummary] = useState(null);
  const [error, setError] = useState(null);

  const run = async (dryRun) => {
    setError(null);
    setLastSummary(null);
    const setBusy = dryRun ? setDryLoading : setLoading;
    setBusy(true);
    try {
      const res = await syncEventVideoFromAffiliates({ dryRun });
      const body = res?.data;
      const summary = body?.data ?? body;
      setLastSummary(summary);
      message.success(body?.message || (dryRun ? 'Dry run finished' : 'Sync finished'));
    } catch (e) {
      const msg =
        e?.response?.data?.message ||
        e?.response?.data?.error ||
        e?.message ||
        'Request failed';
      setError(String(msg));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Card
      title="Sync event video from affiliate galleries"
      className="mb-4"
      extra={
        <Text type="secondary" style={{ fontSize: 12, maxWidth: 320 }}>
          Upcoming published events missing videoStory get the first eligible video from lineup profiles.
        </Text>
      }
    >
      <Paragraph type="secondary" style={{ marginBottom: 12 }}>
        Preview does not write the database or enqueue transcoding. Run applies updates (requires admin token).
      </Paragraph>
      <Space wrap>
        <Button loading={dryLoading} onClick={() => run(true)}>
          Preview (dry run)
        </Button>
        <Button type="primary" loading={loading} danger onClick={() => run(false)}>
          Run sync
        </Button>
      </Space>
      {error && (
        <Alert type="error" message={error} style={{ marginTop: 16 }} showIcon />
      )}
      {lastSummary && (
        <div style={{ marginTop: 16 }}>
          <Text strong>Last result</Text>
          <pre
            style={{
              marginTop: 8,
              padding: 12,
              background: '#f5f5f5',
              borderRadius: 8,
              fontSize: 12,
              maxHeight: 360,
              overflow: 'auto',
            }}
          >
            {JSON.stringify(lastSummary, null, 2)}
          </pre>
        </div>
      )}
    </Card>
  );
}
